/* ==========================================================================
   CUCU - homepage mobile motion state (2026-09-01)

   Two small jobs, both about horizontal movement on the homepage.

   1. RAIL EDGES. Puts at-start / at-end / no-overflow on every homepage
      .cu-rail so cucu-rails.css can open the fade on whichever side still has
      somewhere to go. Same three class names the stories section already uses
      for its own rail, so there is one vocabulary for this on the page rather
      than two.

      Deliberately does nothing else - no arrows, no autoplay, no scroll
      hijacking. The rails are native scrollers and stay native scrollers.

      The CSS default is the at-start appearance, so a rail looks correct even
      if this file never loads. That is why nothing here runs on a timer and
      why a failure is silent rather than visible.

      scan() re-syncs rails it has already wired, not just new ones. Scroll
      position survives back-navigation and can be restored by the browser
      without firing a scroll event, which would otherwise leave a rail sitting
      mid-way with the at-start fade painted on it.

   2. TICKER OFF-SCREEN PAUSE. The trust bar runs an infinite CSS animation on
      phones. The homepage is ~10,000px long, so without this the animation
      keeps compositing for the entire visit while the band is nowhere near the
      screen - a real battery cost for zero benefit. Paused whenever it is out
      of view, cleared (not set to 'running') when it comes back so the CSS
      hover/focus pause still wins.

      Nothing here starts motion. If the observer never runs, the ticker just
      keeps animating, which is the pre-existing behaviour.
   ========================================================================== */
(function () {
  'use strict';

  var HOME = "main[data-template^='index'] ";
  var EPS = 2; /* sub-pixel slack: scrollLeft is fractional on zoomed viewports */

  /* ---------------------------------------------------------- 1. rail edges */

  function sync(rail) {
    var max = rail.scrollWidth - rail.clientWidth;
    rail.classList.toggle('no-overflow', max <= EPS);
    rail.classList.toggle('at-start', rail.scrollLeft <= EPS);
    rail.classList.toggle('at-end', rail.scrollLeft >= max - EPS);
  }

  function wire(rail) {
    if (rail.dataset.cuRailEdges) return;
    rail.dataset.cuRailEdges = '1';

    var raf = 0;
    rail.addEventListener(
      'scroll',
      function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = 0;
          sync(rail);
        });
      },
      { passive: true }
    );

    /* Card images load lazily, so scrollWidth grows after first paint; a
       resize observer catches that as well as orientation changes. */
    if ('ResizeObserver' in window) {
      new ResizeObserver(function () {
        sync(rail);
      }).observe(rail);
    }
  }

  /* ------------------------------------------------------- 2. ticker pause */

  function wireTicker(track) {
    if (track.dataset.cuTickerIo) return;
    if (!('IntersectionObserver' in window)) return;
    track.dataset.cuTickerIo = '1';

    new IntersectionObserver(
      function (entries) {
        /* '' rather than 'running', so the stylesheet's hover / focus-within
           pause is not permanently overridden by an inline declaration. */
        track.style.animationPlayState = entries[0].isIntersecting ? '' : 'paused';
      },
      { rootMargin: '150px 0px' }
    ).observe(track);
  }

  /* ------------------------------------------------------------------ boot */

  function scan() {
    var rails = document.querySelectorAll(HOME + '.cu-rail');
    for (var i = 0; i < rails.length; i++) {
      wire(rails[i]);
      sync(rails[i]);
    }

    var tickers = document.querySelectorAll(HOME + '.cu-tb');
    for (var j = 0; j < tickers.length; j++) wireTicker(tickers[j]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  window.addEventListener('load', scan);
  window.addEventListener('pageshow', scan);
  document.addEventListener('shopify:section:load', scan);
})();
